var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6875 5.37499C15.515 5.37499 15.375 5.23499 15.375 5.06249V2.5625C15.375 2.04562 14.9544 1.625 14.4375 1.625H11.9375C11.765 1.625 11.625 1.485 11.625 1.3125C11.625 1.14 11.765 1 11.9375 1H14.4375C15.2987 1 16 1.70062 16 2.5625V5.06249C16 5.23499 15.86 5.37499 15.6875 5.37499Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 16H11.9375C11.765 16 11.625 15.86 11.625 15.6875C11.625 15.515 11.765 15.375 11.9375 15.375H14.4375C14.9544 15.375 15.375 14.9544 15.375 14.4375V11.9375C15.375 11.765 15.515 11.625 15.6875 11.625C15.86 11.625 16 11.765 16 11.9375V14.4375C16 15.2994 15.2987 16 14.4375 16Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06249 16H2.5625C1.70125 16 1 15.2994 1 14.4375V11.9375C1 11.765 1.14 11.625 1.3125 11.625C1.485 11.625 1.625 11.765 1.625 11.9375V14.4375C1.625 14.9544 2.04562 15.375 2.5625 15.375H5.06249C5.23499 15.375 5.37499 15.515 5.37499 15.6875C5.37499 15.86 5.23499 16 5.06249 16Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3125 5.37499C1.14 5.37499 1 5.23499 1 5.06249V2.5625C1 1.70062 1.70125 1 2.5625 1H5.06249C5.23499 1 5.37499 1.14 5.37499 1.3125C5.37499 1.485 5.23499 1.625 5.06249 1.625H2.5625C2.04562 1.625 1.625 2.04562 1.625 2.5625V5.06249C1.625 5.23499 1.485 5.37499 1.3125 5.37499Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9375 12.875H5.0625C4.54562 12.875 4.125 12.4544 4.125 11.9375V10.0625C4.125 9.89 4.265 9.75 4.4375 9.75C4.61 9.75 4.75 9.89 4.75 10.0625V11.9375C4.75 12.1094 4.89 12.25 5.0625 12.25H11.9375C12.11 12.25 12.25 12.1094 12.25 11.9375V10.0625C12.25 9.89 12.39 9.75 12.5625 9.75C12.735 9.75 12.875 9.89 12.875 10.0625V11.9375C12.875 12.4544 12.4544 12.875 11.9375 12.875Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5625 7.87499C12.39 7.87499 12.25 7.73499 12.25 7.56249V5.0625C12.25 4.89062 12.11 4.75 11.9375 4.75H5.0625C4.89 4.75 4.75 4.89062 4.75 5.0625V7.56249C4.75 7.73499 4.61 7.87499 4.4375 7.87499C4.265 7.87499 4.125 7.73499 4.125 7.56249V5.0625C4.125 4.54562 4.54562 4.125 5.0625 4.125H11.9375C12.4544 4.125 12.875 4.54562 12.875 5.0625V7.56249C12.875 7.73499 12.735 7.87499 12.5625 7.87499Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8125 10.375H3.1875C3.015 10.375 2.875 10.235 2.875 10.0625C2.875 9.89 3.015 9.75 3.1875 9.75H13.8125C13.985 9.75 14.125 9.89 14.125 10.0625C14.125 10.235 13.985 10.375 13.8125 10.375Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanner);
export default __webpack_public_path__ + "static/media/scanner.096da679a7f101259459ed38d59a61a7.svg";
export { ForwardRef as ReactComponent };